import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MenuItems } from './components/MenuItems';
import { Extras } from './components/Extras';
import { DrinkItems } from './components/DrinkItems';
import { Announcements } from './components/Announcements';

const App: React.FC = () => {
  const [selected, setSelected] = React.useState<string>('food');
  const handleSelected = (name: string) => {
    setSelected(name);
  }
  const renderView = (view: string) => {
    switch (view) {
      case 'food':
        return <MenuItems />;
      case 'drinks':
        return <DrinkItems />;
      case 'extras':
        return <Extras />;
      case 'announcements':
        return <Announcements />;
      default:
        return <MenuItems  />;
    }
  }
  return (
    <React.Fragment>
      <Header />
      {renderView(selected)}
      <Footer selected={selected} handleSelected={handleSelected} />
    </React.Fragment>
  );
};

export default App;
